import { Button, Card } from '@roc/ui';
import { Typography, Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import React, { useEffect } from 'react';
import { observer } from 'mobx-react';
import { StandardDialog } from '@roc/ui';
import { ReferralWiringInformation } from '@roc/feature-referrals';

const useStyles = makeStyles(theme => ({
  paper: {
    marginBottom: theme.spacing(2),
    marginRight: theme.spacing(2),
    '& .MuiCardHeader-root': {
      padding: '16px 16px 0 16px',
    },
    '& .MuiCardContent-root': {
      padding: '0 0 16px 0',
    },
  },
  text: {
    fontSize: 11,
    color: '#bdbdbd',
  },
  modalAlignment: {
    margin: '0 auto',
  },
}));

const useDialogContentStyles = makeStyles(theme => ({
  root: {
    padding: 0,
    paddingBottom: 8,
    '& .dialog-content-box': {
      marginTop: 0,
      marginBottom: 16,
    }
  },
}));


export const BankAccounts = observer(({ store }) => {
  const classes = useStyles();
  const dialogContentClasses = useDialogContentStyles();

  return (
    <>
      <Card
        title="Referral Information"
        className={classes.paper}
        cardContentProps={{
          style: {
            display: 'flex',
            flexDirection: 'column',
          },
        }}
      >
        <Typography style={{ margin: '16px' }}>
          Please update your Referral ACH Information so that you can receive
          payment for the referrals you’ve brought to us, once they close a
          loan.
        </Typography>
        <Grid container justifyContent={'center'}>
          <Button
            onClick={() => {
              store.wiringInformationOpen = true;
              store.activeStep = 0;
              store.loadWiringInformationFromMemory();
            }}
            color="primary"
            variant="contained"
            testId="save"
            size={'medium'}
          >
            Update My Information
          </Button>
        </Grid>
      </Card>
      <StandardDialog
        open={store.wiringInformationOpen}
        handleClose={() => {
          store.wiringInformationOpen = false;
          store.edit = false;
        }}
        maxWidth="md"
        title={'Referral ACH Information'}
        dialogContent={<ReferralWiringInformation />}
        dialogContentclasses={dialogContentClasses}
      />
    </>
  );
});
